var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVeganLifestyle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Food-Restaurant-Vegetarian-Vegan-Dish--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Food Restaurant Vegetarian Vegan Dish Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 1.82a1.48 1.48 0 0 0 -2.85 0.57V22.1a0.75 0.75 0 0 0 1.5 0v-6.55h1.81a1.48 1.48 0 0 0 1.48 -1.48c-0.04 -3.63 -0.03 -8.61 -1.94 -12.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.57 12.25a0.75 0.75 0 0 1 0.92 0.53 0.81 0.81 0 0 1 0 0.31 0.76 0.76 0 0 0 -0.26 0 9.94 9.94 0 0 0 -3.46 1.72l-1.42 1.24a0.74 0.74 0 0 0 -0.09 1.05 0.75 0.75 0 0 0 1.06 0.09l0.92 -0.78a3.58 3.58 0 0 0 2 0.58 6 6 0 0 0 4.36 -2.16A7 7 0 0 0 17 9.05a0.7 0.7 0 0 0 -1.13 -0.44 6.86 6.86 0 0 1 -3.62 1.06c-2.17 0.24 -4.62 0.51 -4.62 3.7a3.54 3.54 0 0 0 0.12 0.93l0.35 -0.3a10 10 0 0 1 3.47 -1.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.31a8.56 8.56 0 0 1 -8.94 0 0.75 0.75 0 1 0 -0.79 1.27 9.92 9.92 0 0 0 10.52 0 0.75 0.75 0 0 0 0.25 -1 0.76 0.76 0 0 0 -1.04 -0.27Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94 4.26A9.93 9.93 0 0 0 8.25 4a0.75 0.75 0 0 0 0.61 1.37 8.46 8.46 0 0 1 7.38 0.25 0.73 0.73 0 0 0 0.35 0.09 0.75 0.75 0 0 0 0.66 -0.4 0.73 0.73 0 0 0 -0.31 -1.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.93V1.66a0.75 0.75 0 0 0 -0.75 -0.75 0.75 0.75 0 0 0 -0.75 0.75v4.27a1.73 1.73 0 0 1 -1 1.52V1.66a0.75 0.75 0 0 0 -0.69 -0.75 0.74 0.74 0 0 0 -0.75 0.75v5.78a1.69 1.69 0 0 1 -0.94 -1.51V1.66A0.74 0.74 0 0 0 0.86 0.91a0.75 0.75 0 0 0 -0.75 0.75v4.27A3.2 3.2 0 0 0 2.55 9v13.34a0.74 0.74 0 0 0 0.75 0.75 0.75 0.75 0 0 0 0.7 -0.75V9a3.21 3.21 0 0 0 2.5 -3.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVeganLifestyle);
export default ForwardRef;